// @ts-check

import {
  webhookService
} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  SET_WEBHOOKS,
  ADD_WEBHOOK,
  REPLACE_WEBHOOK,
  SET_USER_VISIBLE_COLUMNS
} from './mutationTypes';
import {
  GET_WEBHOOKS,
  CREATE_WEBHOOK,
  DELETE_WEBHOOK,
  UPDATE_WEBHOOK,
  GET_USER_VISIBLE_COLUMNS,
} from './actionTypes';

import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR } from '@/store/helpers';
import { filter, map } from 'lodash';


/** @type {import('vuex').ActionTree} */
const actions = {

  
  /**
   * Get all Webhooks
   */
  async [GET_WEBHOOKS]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_WEBHOOKS });      
    commit(SET_WEBHOOKS, []);
    try {      
      const {
        data: {
          webHooks
        }
      }= await webhookService.getWebHooks(rootState.currentAccountId);
      commit(SET_WEBHOOKS, webHooks);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_WEBHOOKS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_WEBHOOKS, error: e });
    }
  },

  /**
   * Create Webhook
   */
  async [CREATE_WEBHOOK]({ rootState, commit }, webhook) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: CREATE_WEBHOOK });
    try {
      const response = await webhookService.createWebHook(rootState.currentAccountId, webhook);
      commit(ADD_WEBHOOK, response.data.webHook);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: CREATE_WEBHOOK });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: CREATE_WEBHOOK, error: e });
    }
  },
  async [UPDATE_WEBHOOK]({ rootState, commit }, webhook) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: UPDATE_WEBHOOK });
    try {
      const response = await webhookService.updateWebHook(rootState.currentAccountId, webhook);
      commit(REPLACE_WEBHOOK, response.data.webHook);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: UPDATE_WEBHOOK });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: UPDATE_WEBHOOK, error: e });
    }
  },
  async [DELETE_WEBHOOK]({ rootState, commit, dispatch }, webhookId) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: DELETE_WEBHOOK });
    try {
      await webhookService.deleteWebHook(rootState.currentAccountId, webhookId);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: DELETE_WEBHOOK });
      dispatch(GET_WEBHOOKS);
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: DELETE_WEBHOOK, error: e });
    }
  },
  async [GET_USER_VISIBLE_COLUMNS]({ commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_USER_VISIBLE_COLUMNS });
    commit(SET_USER_VISIBLE_COLUMNS, []);

    try {
      const userVisibleColumns = map(filter(webhookService.columnSettings, (col) => !col.hide), (col) => {
        return col.name || col.displayName;
      });
      commit(SET_USER_VISIBLE_COLUMNS, userVisibleColumns);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_USER_VISIBLE_COLUMNS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_USER_VISIBLE_COLUMNS, error: e });
    }
  },
};

export default actions;